// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QuickTableZone } from '../QuickTable';
export class HitTestInfo {
    constructor(x, y) {
        this.zone = QuickTableZone.Table;
        this.rowIndex = -1;
        this.columnIndex = -1;
        this.realColumnIndex = -1;
        this.x = x;
        this.y = y;
    }
}
